<template>
  <div>
    <b-row>
      <b-col md="12">
        <b-card>
          <template #default>
            <div class="d-flex flex-wrap justify-content-between align-items-center">
              <h3 class="text-center w-100 mb-1">
                {{ $t('reply.posts-page-title',{page:currentPage.name}) }}
              </h3>
              <div class="w-100 d-flex justify-content-center mt-1">
                <b-button
                  variant="primary"
                  size="sm"
                  @click="showEnableByIdModal = true"
                >
                  {{ $t('reply.enable-by-id') }}
                </b-button>
              </div>
            </div>
          </template>
        </b-card>
        <fetching-data-spinner
          :error="error"
          :loading="loading"
          :loading-title="$t('reply.loading-posts')"
          enable-retry
          @retry="fetchPosts"
        />
      </b-col>
      <template v-if="!loading && !error">
        <b-col
          v-for="post in posts"
          :key="post.id"
          lg="4"
          md="6"
          xxs="12"
        >
          <b-card>
            <b-row>
              <b-col
                md="12"
              >
                <b-row>
                  <b-col
                    md="4"
                    sm="6"
                    cols="4"
                  >
                    <b-img
                      :src="post.picture"
                      style="max-height: 100px;width: 100%"
                      alt="Bya3com"
                      rounded
                      thumbnail
                      fluid
                    />
                  </b-col>
                  <b-col
                    md="8"
                    sm="6"
                    cols="8"
                  >
                    <p class="mb-0">
                      {{ post.message }}
                    </p>
                    <p
                      v-if="post.created_time"
                      style="font-size: 12px;"
                      class="text-muted my-0"
                    >
                      {{ post.created_time }}
                    </p>
                  </b-col>
                </b-row>
              </b-col>
              <b-col md="12">
                <div class="d-flex justify-content-between mt-1">
                  <b-button
                    :variant="post.enabled?'warning':'success'"
                    size="sm"
                    class="w-100"
                    @click="post.enabled?goEdit(post):goNew(post)"
                  >
                    {{ $t(`reply.${post.enabled?'edit':'enable'}`) }}
                  </b-button>
                </div>
                <div class="mt-1">
                  <b-button
                    v-if="!!hasLikesFeature"
                    variant="primary"
                    class="w-100"
                    size="sm"
                    @click="showLikesFeature(post)"
                  >
                    {{ $t('page.enable-post-likes') }}
                  </b-button>
                  <b-button
                    v-if="!!hasCommenterFeature"
                    :variant="!!post.enabled_commenter?'warning':'primary'"
                    class="w-100 mt-1"
                    size="sm"
                    :disabled="!!post.enabled_commenter"
                    @click="post.enabled_commenter?null:enableCommenter(post)"
                  >
                    {{ $t(post.enabled_commenter?'page.post-commenter-enabled':'page.enable-post-commenter') }}
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </template>
    </b-row>
    <enable-by-id-modal
      v-model="showEnableByIdModal"
    />
    <likes-feature-modal
      v-model="showLikesFeatureModal"
      :post-id="!!selectedPost?selectedPost.id:null"
      :post="selectedPost"
    />
  </div>
</template>

<script>
import {
  BImg, BRow, BCol, BCard, BButton,
} from 'bootstrap-vue'
import { mapGetters } from 'vuex'
import FetchingDataSpinner from '@/@bya3/components/utils/FetchingDataSpinner'
import PageApi from '@/api/page'
import ReplyApi from '@/api/reply'
import EnableByIdModal from '@/views/owner-fb/page/components/EnableByIdModal.vue'
import LikesFeatureModal from '@/views/owner-fb/page/components/LikesFeatureModal.vue'
import FeaturesApi from '@/api/features'

export default {
  components: {
    LikesFeatureModal,
    EnableByIdModal,
    FetchingDataSpinner,
    BImg,
    BRow,
    BCol,
    BCard,
    BButton,
  },
  data() {
    return {
      posts: [],
      error: null,
      loading: true,
      showEnableByIdModal: false,
      showLikesFeatureModal: false,
      selectedPost: null,
    }
  },
  computed: {
    ...mapGetters({
      currentPageId: 'pages/currentPageId',
      currentPage: 'pages/currentPage',
      hasLikesFeature: 'pages/hasLikesFeature',
      hasCommenterFeature: 'pages/hasCommenterFeature',
    }),
  },
  watch: {
    currentPageId() {
      this.fetchPosts()
    },
  },
  mounted() {
    this.fetchPosts()
  },
  methods: {
    async fetchPosts() {
      this.loading = true
      try {
        const res = await PageApi.postsList(this.currentPageId)
        if (res.error === 0) this.posts = res.posts
        else {
          this.error = res.message
        }
      } catch (e) {
        this.error = e
      } finally {
        this.loading = false
      }
    },
    enableCommenter(post) {
      if (post.enabled_commenter) return
      const self = this
      this.$swal.fire({
        title: self.$t('page.commenter_enabled'),
        text: self.$t('page.page-commenter-hint'),
        showCancelButton: true,
        confirmButtonText: self.$t('forms.submit'),
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          try {
            const response = await FeaturesApi.enablePostCommenter({
              page_id: self.currentPageId,
              post_id: post.id,
              post_text: post.message ?? '',
            })
            if (response.error === 1) {
              return self.$swal.showValidationMessage(response.message ?? '')
            }
            return response
          } catch (error) {
            return self.$swal.showValidationMessage(`
        تعذر اتمام العملية بسبب الخطأ: ${error}
      `)
          }
        },
        allowOutsideClick: () => !self.$swal.isLoading(),
      }).then(result => {
        if (result.isConfirmed) {
          const index = self.posts.findIndex(p => p.id === post.id)
          if (index > -1)self.posts[index].enabled_commenter = 1
          this.$swal.fire({
            title: `${result.value.message}`,
            showCancelButton: false,
            confirmButtonText: self.$t('forms.close'),
          })
        }
      })
    },
    showLikesFeature(post) {
      this.showLikesFeatureModal = true
      this.selectedPost = post
    },
    handleDelete(post) {
      this.$okConfirm(this.$t('reply.delete-reply-message'), {
        preConfirm: () => ReplyApi.deleteReply(post.id)
          .then(response => {
            this.$notifySuccess(response.message)
            const index = this.posts.findIndex(p => p.id === post.id)
            if (index > -1) this.posts[index].enabled = false
          })
          .catch(e => this.$notifyError(e)),
      })
    },
    goEdit(post) {
      this.$store.commit('reply/SET_FORM', { post_description: post?.full_message ?? '', post_thumb: post.picture })
      this.$router.push({ name: 'owner:reply-edit', params: { id: post.id } })
    },
    goNew(post) {
      this.$store.commit('reply/SET_FORM', { post_description: post?.full_message ?? '', post_thumb: post.picture })
      this.$router.push({ name: 'owner:reply', params: { id: post.id } })
    },
  },
}
</script>
